module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-51c3c29c65ad68aedd18fae6b90a6dce.webp";